import { toast } from 'react-toastify';
import fetchWithAuth from 'shared/services/fetchWithAuth';

type NotLoadedPrizesFile = {
  url: string;
  fileName: string;
};

export const downloadNotLoadedPrizes = ({ url, fileName }: NotLoadedPrizesFile) => {
  fetchWithAuth(url, { method: 'GET' })
    .then((response) => {
      if (!response.ok) {
        // Handle non-403 errors
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.blob();
    })
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    })
    .catch(() => {
      toast.error('Произошла ошибка при скачивании файла', {
        position: toast.POSITION.TOP_RIGHT,
      });
    });
};
